import { Component, OnInit } from '@angular/core';
import { ModalService } from '../../services/modal.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SettingsService } from '../../../core/http/settings.service';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
  selector: 'app-opd-detail-modal',
  templateUrl: './opd-detail-modal.component.html',
  styleUrls: ['./opd-detail-modal.component.scss']
})
export class OpdDetailModalComponent implements OnInit {
  isLoading = false;
  Errors = null;
  titles = null;
  mode = "add";
  items = null
  data = null
  Success = null
  visible = false
  opds: any = []
  itemId
  itemName = "";
  itemAmount = 0;
  discount = 0;
  discountPrice = 0;
  netAmount = 0;
  lstServices: any = []
  serchItems = []
  filterddata: any = [];
  packages: any = []
  private _searchText:string ;

  get searchText(): string {
      return this._searchText;
  }

  set searchText(value: string) {
    this._searchText = value;
    this.filterddata = this.filterdata(value)
}

filterdata(searchString: string) {
    return this.titles.filter( log =>
      log.service_name.toLowerCase().indexOf(searchString.toLowerCase()) !== -1);
}

  stateForm = new FormGroup({
    id: new FormControl(null, Validators.required),
    pack_id: new FormControl(0, Validators.required),
    lstServices: new FormControl([], Validators.required),
  });

  constructor(private modal: ModalService, private _snackBar: MatSnackBar, public auth: SettingsService) { }

  onSubmit(e) {
    e.preventDefault();
    this.isLoading = true;
    this.Errors = null;
    this.Success = null;
    const {
      id,
      pack_id,
      lstServices,
    } = this.stateForm.value;
    this.auth
      .postOpdDetail(
        id,
        pack_id,
        lstServices,

      )
      .subscribe(
        (resSuccess) => {

          this.data = resSuccess
          this.isLoading = false;

          if (this.data.success) {
            this.closeModal()
            this._snackBar.open('Saved Successfully', '', {
              duration: 2000,
              verticalPosition: 'top',
            });
          }
          else {
            this.Errors = "Not successful, please try again"
            console.log(resSuccess)
          }

        },
        (resErr) => {
          this.isLoading = false;
          this.Errors = resErr;
          console.log(resErr)
        }
      );
  }

  closeModal() {
    this.modal.closeModal();
  }

  ngOnInit(): void {
    this.auth
      .getItems()
      .subscribe(
        (resSuccess) => {

          this.items = resSuccess
        },
        (resErr) => {
          this.Errors = resErr;
        }
      );

      this.auth
      .getOpd()
      .subscribe(
        (resSuccess) => {

          this.opds = resSuccess
        },
        (resErr) => {
          this.Errors = resErr;
        }
      );

    // this.auth
    //   .getOpdDetail()
    //   .subscribe(
    //     (resSuccess) => {

    //       this.titles = resSuccess
    //       this.filterddata = this.titles
    //       this.isLoading = false;
    //     },
    //     (resErr) => {
    //       this.isLoading = false;
    //       this.Errors = resErr;
    //     }
    //   );
  }
  addNew(items) {
    this.mode = "add"
  }
  edit(title) {
    this.mode = "edit"
    this.stateForm.patchValue({
      id: title.id,
      service_id: title.service_id,
      service_name: title.service_name,
      service_price: title.service_price,
      discount_percent: title.discount_percent,
      discount_price: title.discount_price,
      net_amt: title.net_amt,
    });
    console.log(this.stateForm.value)
  }

  percentage(percent, total) {
    return ((percent/ 100) * total)
}

  onChange() {
    this.discountPrice = this.percentage(this.discount, this.itemAmount)
    this.netAmount = this.itemAmount - this.discountPrice

    console.log(this.discountPrice, this.netAmount, this.itemAmount, this.itemId, this.itemName);

  }

  refchg(value) {
    if(value == "") {
      this.visible = false
    }else {
      this.visible = true
    }
    this.serchItems = this.items.filter(t => t.name.toLowerCase().indexOf(value.toLowerCase()) !== -1)
  }

  cngPackage(event) {
  console.log(event);
  this.auth
  .getOpdDetailPackage(event)
  .subscribe(
    (resSuccess) => {
      this.packages = []
      this.packages = resSuccess
      console.log(this.packages);

    },
    (resErr) => {
      this.Errors = resErr;
    }
  );

  }
  back() {
    this.mode = "add"
  }
  dlt() {
    this.mode = "delete"
  }

  deleteDetail(id, pack_id) {
    this.auth
    .deleteDetail(id, pack_id)
    .subscribe(
      (resSuccess: any) => {

        console.log(resSuccess);
        if(resSuccess.success) {
          this.cngPackage(pack_id)
          this._snackBar.open('Delete Succesfully', '', {
              duration: 2000,
              verticalPosition: 'top',
            });
        }else {
          this._snackBar.open('Error please try again', '', {
              duration: 2000,
              verticalPosition: 'top',
            });
        }

      },
      (resErr) => {
        this.Errors = resErr;
      }
    );
  }
  setItem(item) {
    this.itemName = item.name
    this.itemId = item.id
    this.itemAmount = item.service_price
     console.log(item);

     this.visible = false
     console.log(this.stateForm.value);

   }

   deleteItem(service) {
    this.lstServices = this.lstServices.filter(t => t.service_id !== service)
   }
   add() {
     this.onChange()
    this.lstServices.push(
      {
        service_id: this.itemId,
        service_name: this.itemName,
        service_price: this.itemAmount,
        discount_percent: this.discount,
        discount_price: this.discountPrice,
        net_amt: this.netAmount
      }
    )
    this.stateForm.patchValue({
      lstServices: this.lstServices
    });
    this.itemId = ""
    this.itemName = ""
    this.itemAmount = 0
    this.discount = 0
    this.discountPrice = 0
    this.netAmount = 0
    console.log(this.stateForm.value);


   }

  delete(title) {
    this.auth
      .delSet("/api/opdpackage/detail/delete", title.id)
      .subscribe(
        (resSuccess) => {
          this.filterddata = this.filterddata.filter(dattum => dattum.id !== title.id)
          this._snackBar.open('Deleted Successfully', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
        },
        (resErr) => {
          this._snackBar.open('Error try again', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
        }
      );
  }

}
